var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0684 10.7125L23.7037 0.347863C23.481 0.125133 23.179 0 22.864 0H7.38537C5.28914 0 3.58374 1.7054 3.58374 3.80163V34.1984C3.58374 36.2946 5.28914 38 7.38537 38H30.6144C32.7107 38 34.4161 36.2946 34.4161 34.1984V11.5521C34.4161 11.2372 34.291 10.9352 34.0684 10.7125ZM24.0515 4.05442L30.3617 10.3647H24.0515V4.05442ZM30.6145 35.625H7.38537C6.59873 35.625 5.95874 34.985 5.95874 34.1984V3.80163C5.95874 3.01499 6.59873 2.375 7.38537 2.375H21.6765V11.5521C21.6765 12.2079 22.2082 12.7396 22.864 12.7396H32.0411V34.1983C32.0411 34.985 31.4012 35.625 30.6145 35.625Z",
    fill: "#D7181D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0515 4.05442L30.3617 10.3647H24.0515V4.05442Z",
    fill: "#D7181D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6145 35.625H7.38537C6.59873 35.625 5.95874 34.985 5.95874 34.1984V3.80163C5.95874 3.01499 6.59873 2.375 7.38537 2.375H21.6765V11.5521C21.6765 12.2079 22.2082 12.7396 22.864 12.7396H32.0411V34.1983C32.0411 34.985 31.4012 35.625 30.6145 35.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.ab8fa9a303833c977916e1d98b0b5869.svg";
export { ForwardRef as ReactComponent };